import API from './api';
import Modal from 'react-modal';
import React, {Component} from 'react';
import {Input, TextArea, YearInput} from './form';
import {ToastContainer, toast} from 'react-toastify';

class Stars extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    }
  }

  highlight(i) {
    this.setState({value: i+1});
  }

  reset() {
    this.setState({value: this.props.value})
  }

  render() {
    return (
      <div className={`form-field-stars ${this.props.className}`} onMouseLeave={this.reset.bind(this)}>
        {Array.from(Array(5).keys()).map((i) => {
          let icon = i < this.state.value ? 'icon-star' : 'icon-star-o';
          return <span
            key={i}
            className={`star ${icon}`}
            onClick={() => this.props.onClick(i+1)}
            onMouseEnter={() => this.highlight(i)}></span>;
        })}
      </div>
    );
  }
}

class ReviewButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false
    }
  }

  close() {
    this.setState({modalIsOpen: false});
  }

  render() {
    return (
      <div>
        <ToastContainer />
        <a className='button' onClick={() => this.setState({modalIsOpen: true})}>{this.props.text}</a>
        <Modal
          className='modal review-modal'
          isOpen={this.state.modalIsOpen}>
          <ReviewForm orgId={this.props.id}
            onSubmit={this.close.bind(this)}
            onCancel={this.close.bind(this)}/>
        </Modal>
      </div>
    );
  }
}

class ReviewForm extends Component {
  static required = [
    'year_attended', 'program_name'
  ]

  constructor(props) {
    super(props);
    this.state = {
      form: {
        text: '',
        year_attended: props.year_attended || '',
        program_name: props.program_name || '',
        alumni_only: false,
        facilities: 0,
        staff: 0,
        value: 0,
        setting: 0,
        community: 0,
        recommended: null
      },
      errs: {}
    }

    this.onInputChange = this.onInputChange.bind(this);
  }

  onInputChange(ev) {
    const target = ev.target;
    const name = target.name;
    let value = target.value;
    let state = this.state;

    if (ev.target.type === 'checkbox') {
      value = ev.target.checked;
    }

    state.form[name] = value;
    this.setState(state);
  }

  validate() {
    let invalid = ReviewForm.required.filter(k => !(this.state.form[k]) || this.state.form[k].length === 0);
    if (invalid.length > 0) {
      let errs = invalid.reduce((acc, k) => {
        acc[k] = 'This field is required.';
        return acc;
      }, {});
      if (!this.state.form.alumni_only && this.state.form.text.length === 0) {
        errs['text'] = 'This field is required.';
      }
      toast.error('Some required fields are missing.');
      this.setState({errs: errs});
      return false;
    }
    return true;
  }

  setStars(key) {
    return (i) => {
      let state = this.state;
      state.form[key] = i;
      this.setState(state);
    };
  }

  setRecommended(val) {
    let state = this.state;
    state.form.recommended = val;
    this.setState(state);
  }

  submit() {
    if (this.validate()) {
      // update
      if (this.props.id) {
        API.post(`/creatives/reviews/${this.props.id}`, this.state.form, (data) => {
          if (data.success) {
            toast.success('Your review has been updated.');
            this.props.onSubmit(this.state.form);
          } else {
            toast.error('Something went wrong.');
          }
        });

      // new
      } else {
        API.post(`/orgs/${this.props.orgId}/reviews`, this.state.form, (data) => {
          if (data.success) {
            toast.success('Your review has been submitted.');
            this.props.onSubmit();
          } else {
            toast.error('Something went wrong.');
          }
        });
      }
    }
  }

  render() {
    let review_form = '';
    if (!this.state.form.alumni_only) {
      review_form = (
        <div>
          <h2>Write a public review</h2>
          <p className='muted'>Please remember these reviews are public. Be respectful and mindful with your word choices regardless if the review itself is positive or negative.</p>
          <TextArea name='text' maxLength={1000} placeholder='Your review' onChange={this.onInputChange} value={this.state.form.text} error={this.state.errs.text} />
          <h2>Rate your experience</h2>
          <div className='form-field-stars-group'>
            <div className='form-field flex flex-2col align-center-vertical'>
              <div>Facilities & Accommodation</div>
              <Stars value={this.state.form.facilities} onClick={this.setStars('facilities')} className={this.state.form.facilities > 0 ? 'form-field-stars-selected' : ''}/>
            </div>
            <div className='form-field flex flex-2col align-center-vertical'>
              <div>Staff</div>
              <Stars value={this.state.form.staff} onClick={this.setStars('staff')}  className={this.state.form.staff > 0 ? 'form-field-stars-selected' : ''}/>
            </div>
            <div className='form-field flex flex-2col align-center-vertical'>
              <div>Value & Alumni Impact</div>
              <Stars value={this.state.form.value} onClick={this.setStars('value')}  className={this.state.form.value > 0 ? 'form-field-stars-selected' : ''}/>
            </div>
            <div className='form-field flex flex-2col align-center-vertical'>
              <div>Environment & Setting</div>
              <Stars value={this.state.form.setting} onClick={this.setStars('setting')} className={this.state.form.setting > 0 ? 'form-field-stars-selected' : ''}/>
            </div>
            <div className='form-field flex flex-2col align-center-vertical'>
              <div>Community & Social Atmosphere</div>
              <Stars value={this.state.form.community} onClick={this.setStars('community')} className={this.state.form.community > 0 ? 'form-field-stars-selected' : ''}/>
            </div>
            <div className='form-field flex flex-2col align-center-vertical'>
              <div>Would you recommend this program?</div>
              <div className='form-field-thumbs'>
                <span
                  className={`thumbs icon-thumbs-up ${this.state.form.recommended === true ? 'selected' : ''}`}
                  onClick={() => this.setRecommended(true)}></span>
                <span
                  className={`thumbs icon-thumbs-down ${this.state.form.recommended === false ? 'selected' : ''}`}
                  onClick={() => this.setRecommended(false)}></span>
              </div>
            </div>
          </div>
        </div>
      );
    }

    let alumni_form = '';
    if (!this.props.reviewOnly) {
      alumni_form = (
        <div>
          <h2>Alumni verification</h2>
          <p className='muted'>We first have to verify your participation in this organization's programs. Once you are verified, your review will be posted onto the organization's public profile page.</p>
          <div className='form-field flex flex-2col'>
            <YearInput name='year_attended' value={this.state.form.year_attended} placeholder='Year attended' onChange={this.onInputChange} error={this.state.errs.year_attended} />
            <Input type='text' name='program_name' value={this.state.form.program_name} placeholder='Program attended' onChange={this.onInputChange} error={this.state.errs.program_name} />
          </div>
          <div className='form-field'>
            <input type='checkbox' name='alumni_only' id='alumni_only' checked={this.state.form.alumni_only} onChange={this.onInputChange}/><label htmlFor='alumni_only'>Apply for Alumni Status without leaving a review</label>
            {this.state.form.alumni_only && <p className='muted'>You are only submitting an alumni verification and not submitting a review.</p>}
          </div>
      </div>);
    }

    return (
      <div>
        <h1>Leave a Review</h1>
        {alumni_form}
        {review_form}
        <div className='modal-actions'>
          <div className='button' onClick={this.props.onCancel}>Cancel</div>
          <div className='button' onClick={this.submit.bind(this)}>Submit</div>
        </div>
      </div>
    );
  }
}

export {ReviewButton, ReviewForm};



// WEBPACK FOOTER //
// ./res/front/static/js/review.js